module.exports = __webpack_public_path__ + "img/bj-blueberry.5c1349ac.gif";